import React from 'react';
import PropTypes from 'prop-types';
import * as Scroll from 'react-scroll';
import { Section, SectionHeader, Paragraph, Link } from 'components';
import './Contact.scss';

const SpyLink = Scroll.Link;

const Contact = ({ background, title, content, cta, link, scroll, id }) => (
  <Section
    color={'pigeon-post'}
    additionalClass={'career__contact-section section--centered'}
    background={background}
  >
    <SectionHeader
      additionalClass={'headline--centered'}
      color={'white'}
      size={'medium'}
      lineColor={'black'}
      headingType={2}
    >
      {title}
    </SectionHeader>
    <Paragraph
      additionalClass={'text--light paragraph--text-centered'}
      color={'black'}
      size={'medium'}
    >
      {content}
      <span />
      {scroll ? (
        <SpyLink
          id={id}
          to={link}
          spy={false}
          smooth
          duration={500}
          className={
            'link__underline--centered link__underline link__underline--white'
          }
        >
          <span className="text--bold">{cta}</span>
        </SpyLink>
      ) : (
        <Link
          additionalClass={'link__underline--centered career-mail'}
          to={link}
          underline={'white'}
        >
          <span className="text--bold">{cta}</span>
        </Link>
      )}
    </Paragraph>
  </Section>
);

Contact.defaultProps = {
  background: '',
  title: '',
  content: '',
  cta: '',
  link: '',
  scroll: false,
  id: '',
};

Contact.propTypes = {
  background: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  title: PropTypes.string,
  content: PropTypes.string,
  cta: PropTypes.string,
  link: PropTypes.string,
  scroll: PropTypes.bool,
  id: PropTypes.string,
};

export default Contact;
